import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { IomCreateproposal, DDCount } from '../../models/iom-createproposal';
import { SessionService } from '../../services/session.service';
import { HttpErrorResponse } from '@angular/common/http';
import { IomService } from 'src/app/services/iom.service';
import { MessageService } from 'src/app/services/message.service';
import { DeepDiveDetails } from 'src/app/models/DeepDiveDetails';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConfigService } from 'src/app/services/app-config.service';
import { EllipsisModule } from 'ngx-ellipsis';
declare var $: any;

@Component({
  selector: 'app-prop-summary',
  templateUrl: './prop-summary.component.html',
  styleUrls: ['./prop-summary.component.css']
})
export class PropSummaryComponent implements OnInit {

  propSummaryList: IomCreateproposal;
  selectedclientName: String;
  selectedprojectName: String;
  selectedproposalName: string;
  client: string;
  project: string;
  clientGroup: String;
  market: String;
  marketUnit: String;
  opportunityId: String;
  proposalName: String;
  proposalId: any;
  userAccess: String;
  createdBy: String;
  CreatedOn: String;
  ModifiedOn: String;

  loggedInUser: string;
  PropSummaryDetailList: IomCreateproposal[];
  marketList: { MarketName: string, MarketId: number }[];
  marketUnitList: { MarketUnitId: number, MarketUnitName: string }[];
  ClientGroupList: { ClientGroupId: number, ClientGroupName: string }[];
  ProposalDetailList: IomCreateproposal[];
  DistinctClientList: String[];
  ProjectDetails: IomCreateproposal[];
  ProjectDetails1: IomCreateproposal[];
  ProjectDetails_FDS: String[];
  ProjectDetails1_FDS: String[];
  FilteredProposalDetails: String[];
  FilteredProposalDetails1: String[];
  DistinctMarketList: String[];
  DistinctMarketUnitList: String[];
  DistinctClientGroupList: String[];
  DistinctProposalList: String[];

  DeepDiveData: DeepDiveDetails[];
  DeepDiveDataFiltered: DeepDiveDetails[];

  proposal: {
    NoOfClients, E2EUIDs, IsAuthorized, Market: { MarketName: string, MarketId: number }[],
    MarketUnit: { MarketUnitId: number, MarketUnitName: string }[],
    ClientGroup: { ClientGroupId: number, ClientGroupName: string }[],
    ProposalDetail: IomCreateproposal[], DomainWithDDCount: DDCount[] ,ProjectName :string
  }; proposalDetail: IomCreateproposal[] = [];
  show = false;
  isLoadShowSub = false;
  DistinctAoList: string[];
  DistinctOthersList: string[];
  DistinctIoList: string[];
  FilteredClientDetails: IomCreateproposal;
  isCheck = false;
  ProjectDetails2: String[];
  FilteredProposalDetails2: IomCreateproposal[];
  ClientProjectDetails: String[];
  ClientProposalDetails: String[];
  ProjectProposalDetails: String[];
  deepdivenumber: any;
  Domain: any;
  DeepdiveCount: any;
  ddCount: any;
  ddCount1: any;
  DistinctClientList1: String[];
  AoddCount: any;
  IoddCount: any;
  OthersddCount: any;
  AoddCountdetails: any;
  IoddCountdetails: any;
  OthersddCountdetails: any;
  clientlistLength: number;
  proposallistLength: number;
  clientName: String;
  projectName: String;
  addactive: boolean = false;
  FilteredProjectDetails: String[];
  isLoadHTML:boolean=false;
  envVar: any;
  barnumber = 50;
  currentPage = 1;
  totalPage: number;

  constructor(private route: ActivatedRoute, private spinner: NgxSpinnerService, private messageService: MessageService, private sessionservice: SessionService, private router: Router, private iomservice: IomService, private appConfigService: AppConfigService) {
    //console.log(this.proposal);
    this.envVar = this.appConfigService.getEnvironment();
    this.clearScopeSelection();
  }

  ngOnInit() {    
    $('#standScope').hide();   
    //this.spinner.show();
    this.loggedInUser = this.sessionservice.getUserName();
    //this.GetProData();
    // if (this.router.url.startsWith('/proposalsummary/')) {
    //   // this.route.paramMap.subscribe(params => {
    //   //   let opportunityId = params.get('opportunityId');
    //   //   if (opportunityId)
    //   //     this.GetProposalDataByOppId(opportunityId);
    //   //   else
    //   //     this.GetProData();
    //   // });
    //   this.GetDeepDiveCount();
    // }
    this.selectedclientName = 'Select Client';
    this.selectedprojectName = 'Select E2E';
    if (this.envVar.Env == "FDS_ManualUpload" || this.envVar.Env == 'SAAS_ManualUpload'){
      this.selectedprojectName = 'Select Project';
    }
    this.selectedproposalName = 'Select Opportunity';    
    this.GetProData();
    //this.GetDeepDiveCount();   
  }

  GetProData() {
    this.spinner.show();
    this.isLoadHTML= false;
    this.iomservice.getProp<any>(this.sessionservice.getUserName(), "").subscribe(data => {
      //console.log(data);
      this.spinner.hide();
      if (data.E2EUIDs == 0 && data.NoOfClients == 0) {       
        this.clearScopeSelection();
        this.iomservice.IsAuthorized = false;       
        this.iomservice.setScopeStatus('Loaded');
        this.router.navigate(['accessdenied']);
      }
      else
      {
        this.isLoadHTML= true;
      }
      this.sessionservice.setSessionStorageItem("ProposalData", JSON.stringify(data))
      if (this.sessionservice.getSessionStorageItem('ProposalData') != null && this.sessionservice.getSessionStorageItem('ProposalData') != 'null' && this.sessionservice.getSessionStorageItem('ProposalData') != '') {
        const str = this.sessionservice.getSessionStorageItem('ProposalData')
         data = eval('(' + str + ')');
       }
      this.proposal = data;
      // if (this.proposal.IsAuthorized == 0){
      //   this.router.navigate(['accessdenied']);
      // }
      this.proposalDetail = this.proposal.ProposalDetail;
      this.ProposalDetailList = this.proposal.ProposalDetail;
      this.DistinctClientList = [...new Set(this.proposal.ProposalDetail.map(x => x.ClientName))];

      this.totalPage = Math.ceil(this.DistinctClientList.length / this.barnumber);
      this.DistinctClientList1 = this.DistinctClientList.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
      //this.DistinctClientList1 = [...new Set(this.proposal.ProposalDetail.map(x => x.ClientName))];
      this.DistinctProposalList = [...new Set(this.proposal.ProposalDetail.map(x => x.ProposalName))];
      this.proposallistLength = this.proposal.E2EUIDs;            
      if (this.envVar.Env == "FDS_ManualUpload" || this.envVar.Env == "SAAS_ManualUpload"){
         this.proposallistLength = this.DistinctProposalList.length;
      }
      this.clientlistLength = this.proposal.NoOfClients;

      this.ddCount = this.proposal.DomainWithDDCount;
      this.AoddCount = this.proposal.DomainWithDDCount.find(x => x.Domain == "AO").DeepdiveCount;
      this.IoddCount = this.proposal.DomainWithDDCount.find(x => x.Domain == "IO").DeepdiveCount;
      this.OthersddCount = this.proposal.DomainWithDDCount.find(x => x.Domain == "Others").DeepdiveCount;
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error Occured !");
      });
  }

  // GetDeepDiveCount() {
  //   this.iomservice.getDeepDiveCount<any>(this.sessionservice.getUserName()).subscribe(data => {
  //     //console.log(data);
  //     this.ddCount = data;
  //     // this.loadAoddCount();
  //     // this.loadIoddCount();
  //     // this.loadOthersddCount();
  //     if (this.ddCount && this.ddCount.length > 0) {
  //       this.AoddCountdetails = this.ddCount.find(x => x.Domain == "AO");
  //       if (this.AoddCountdetails)
  //         this.AoddCount = this.AoddCountdetails.DeepdiveCount;
  //       else
  //         this.AoddCount = 0;
  //       this.IoddCountdetails = this.ddCount.find(x => x.Domain == "IO");
  //       if (this.IoddCountdetails)
  //         this.IoddCount = this.IoddCountdetails.DeepdiveCount;
  //       else
  //         this.IoddCount = 0;
  //       this.OthersddCountdetails = this.ddCount.find(x => x.Domain == "Others");
  //       if (this.OthersddCountdetails)
  //         this.OthersddCount = this.OthersddCountdetails.DeepdiveCount;
  //       else
  //         this.OthersddCount = 0;
  //     }
  //   },
  //     (err: HttpErrorResponse) => {
  //       console.log("Error Occured !");
  //     });
  // }


  GetProposalDataByOppId(opportunityId) {
    this.iomservice.getProp<any>(this.sessionservice.getUserName(), "").subscribe(data => {
      this.proposal = data;
      this.proposalDetail = this.proposal.ProposalDetail;
      this.propSummaryList = this.proposal.ProposalDetail.find(x => x.OpportunityId == opportunityId)
      this.clientName = this.propSummaryList.ClientName;
      this.clientGroup = this.propSummaryList.ClientGroup;
      this.market = this.propSummaryList.Market;
      this.projectName = this.propSummaryList.ProjectName;
      this.marketUnit = this.propSummaryList.MarketUnit;
      this.opportunityId = this.propSummaryList.OpportunityId;
      this.proposalName = this.propSummaryList.ProposalName;
      this.proposalId = this.propSummaryList.ProposalId;
      this.userAccess = this.propSummaryList.UserAccess;
      this.createdBy = this.propSummaryList.CreatedByUser;
    },
      (err: HttpErrorResponse) => {
        console.log("Error Occured !");
      });
  }
  UpdateProposalId(propId, isLoad, clientName, ProposalName) {
    
    this.sessionservice.setE2EUId(propId);   
    if (this.envVar.Env == "FDS_ManualUpload") {
      this.sessionservice.setSessionStorageItem("userType", "1");      
    }
    else{
      this.sessionservice.setSessionStorageItem("userType", "3");  
      sessionStorage.setItem("Instance", 'SAAS');   
    }
    //this.sessionservice.setSessionStorageItem("selectedProposalId", propId);
    if (isLoad == "YES") {     
      this.sessionservice.setDeliveryConstructUId(propId);  
      this.sessionservice.setSessionStorageItem("clientName", clientName);
      this.sessionservice.setDeliveryConstructName(ProposalName);
      this.sessionservice.setE2EDeliveryConstructName(ProposalName); // e2ename 
      sessionStorage.setItem("redirecttoStandalone", "standalone");
      this.sessionservice.setSessionStorageItem("selectedProposalId", propId);
      this.messageService.loadHeader(propId);      
          
    }   
    else{
      this.sessionservice.setSessionStorageItem("clientName", clientName);
      this.sessionservice.setDeliveryConstructName(ProposalName); // e2ename
      this.sessionservice.setSessionStorageItem("selectedProposalId", propId);
      sessionStorage.setItem("redirecttoStandalone", "standalone");
    }    
  }
  UpdateProposalIdFDS(propId) {
    this.sessionservice.setSessionStorageItem("selectedProposalId", propId);
    this.messageService.loadHeader(propId);
  }
 

  onlyEdit() {
    this.createdBy == this.loggedInUser
  }


  ToggleCategory(e, client) {
    this.spinner.show();
    if ($(e.target).parents('.iom-category').hasClass('open')) {
      $('.iom-category').removeClass('open');
    } else {
      $('.iom-category').removeClass('open');
      $(e.target).parents('.iom-category').toggleClass('open');
    }
    var data = this.ProposalDetailList.filter(x => x.ClientName == client);
    this.ProjectDetails1 = data;
    if(this.envVar.Env == "FDS_ManualUpload"){
      this.ProjectDetails1_FDS = [...new Set(data.map(x => x.ProjectName))];
    }
    else if (this.envVar.Env == 'SAAS_ManualUpload')
    {
      this.ProjectDetails1_FDS = [...new Set(data.map(x => x.ProjectName))];
    }        
    this.spinner.hide();
  }

  ToggleClient(e, client, project) {
    this.spinner.show();
    if ($(e.target).parents('.iom-client').hasClass('open')) {
      $('.iom-client').removeClass('open');
    } else {
      $('.iom-client').removeClass('open');
      $(e.target).parents('.iom-client').toggleClass('open');
    }
    var data = this.ProposalDetailList.filter(x => (x.ClientName == client && x.ProjectName == project));
    this.FilteredProposalDetails1 = [...new Set(data.map(x => x.ProposalName))];
    this.FilteredProposalDetails2 = data;
    this.isCheck = !this.isCheck;
    this.spinner.hide();
  }

  loadProjectDetails(selectedClient) {
    if (this.selectedclientName = 'Select Client') {
      this.selectedprojectName = 'Select E2E';
      this.selectedproposalName = 'Select Opportunity';
    }
    this.selectedclientName = selectedClient;
    var data = this.ProposalDetailList.filter(x => x.ClientName == this.selectedclientName);
    this.FilteredProjectDetails = [...new Set(data.map(x => x.ProjectName))];
    if (this.envVar.Env == "FDS_ManualUpload" || this.envVar.Env == 'SAAS_ManualUpload'){
      this.selectedprojectName = 'Select Project';
      this.ProjectDetails_FDS = [...new Set(data.map(x => x.ProjectName))];
    }    
    // this.FilteredProposalDetails = [];
  }

  loadProposalDetails(selectedProject) {
    if (this.selectedprojectName = 'Select E2E') {
      this.addactive = true;
      this.selectedprojectName = 'Select E2E';
      this.selectedproposalName = 'Select Opportunity';
    }
    this.selectedprojectName = selectedProject;
    var data = this.ProposalDetailList.filter(x => x.ClientName == this.selectedclientName && x.ProjectName == this.selectedprojectName);
    this.FilteredProposalDetails = [...new Set(data.map(x => x.ProposalName))];
  }

  selectedOpportunity(selectedOpportunity) {
    this.selectedproposalName = selectedOpportunity;
  }

  loadClientProjectDetails(clientName) {
    let strclientName;
    var data = this.ProposalDetailList.filter(x => x.ClientName == clientName);
    this.ClientProjectDetails = [...new Set(data.map(x => x.ProjectName))];
    strclientName = this.ClientProjectDetails.join();
    return strclientName;

    //this.FilteredProposalDetails= [];
  }

  loadClientProposalDetails(clientName) {
    let strclientPropName;
    var data = this.ProposalDetailList.filter(x => x.ClientName == clientName);
    this.ClientProposalDetails = [...new Set(data.map(x => x.ProposalName))];
    strclientPropName = this.ClientProposalDetails.join();
    return strclientPropName;
  }

  loadProjectProposalDetails(projectName, clientName) {
    let strProjectPropName;
    var data = this.ProposalDetailList.filter(x => x.ClientName == clientName).filter(x => x.ProjectName == projectName);
    this.ProjectProposalDetails = [...new Set(data.map(x => x.ProposalName))];
    strProjectPropName = this.ProjectProposalDetails.join();
    return strProjectPropName;
  }

  loadAoddCount() {
    let strAOddCount;
    if (this.ddCount.find(x => x.Domain == "AO")) {
      return strAOddCount = this.ddCount[0].DeepdiveCount;
    } else {
      return strAOddCount = 0
    }
  }

  loadIoddCount() {
    let strIOddCount;
    if (this.ddCount.find(x => x.Domain == "IO")) {
      return strIOddCount = this.ddCount[0].DeepdiveCount;
    } else {
      return strIOddCount = 0
    }
  }

  loadOthersddCount() {
    let strOthersddCount;
    if (this.ddCount.find(x => x.Domain == "Others")) {
      return strOthersddCount = this.ddCount[0].DeepdiveCount;
    } else {
      return strOthersddCount = 0
    }
  }

  onSearch() {
    this.spinner.show();
    if (this.selectedclientName == "Select Client") {
      this.DistinctClientList1 = this.DistinctClientList;
      if(this.selectedprojectName == "Select Project" || this.selectedprojectName == "Select E2E"){
        if (this.envVar.Env == "FDS_ManualUpload" || this.envVar.Env == 'SAAS_ManualUpload'){
        if (this.selectedprojectName == "Select Project") {
          this.ProjectDetails1_FDS = this.ProjectDetails_FDS;
        }
      }
        else{
          if (this.selectedprojectName == "Select E2E") {
            this.ProjectDetails1 = this.ProjectDetails;
          }
        }
        if (this.selectedproposalName == "Select Opportunity") {
          this.FilteredProposalDetails1 = this.FilteredProposalDetails;
        } else {
          this.FilteredProposalDetails1 = this.FilteredProposalDetails.filter(x => x == this.selectedproposalName);
        }
      } else {
        if (this.envVar.Env == "FDS_ManualUpload" || this.envVar.Env == 'SAAS_ManualUpload'){
        this.ProjectDetails1_FDS = this.ProjectDetails_FDS.filter(x => x == this.selectedprojectName);
        }else{
        this.ProjectDetails1 = this.ProjectDetails.filter(x => x.ProjectName == this.selectedprojectName);
        }
      }
    } else {
      this.DistinctClientList1 = this.DistinctClientList.filter(x => x == this.selectedclientName);
    }
    this.spinner.hide();
  }
  onReset() {
    this.spinner.show();
    this.ToggleCategory(Event, this.client);
    this.selectedclientName = "Select Client";
    if(this.envVar.Env!="FDS_ManualUpload"){
    this.selectedprojectName = "Select E2E";
    }
    else{
      this.selectedprojectName = "Select Project";
    }
    this.selectedproposalName = "Select Opportunity";
    this.ProjectDetails1 = [];
    this.ProjectDetails = [];
    this.FilteredProjectDetails = [];
    this.DistinctClientList1 = this.DistinctClientList;
    this.FilteredProposalDetails1 = this.FilteredProposalDetails;
    if (this.envVar.Env == "FDS_ManualUpload" || this.envVar.Env == 'SAAS_ManualUpload'){
      this.ProjectDetails1_FDS = this.ProjectDetails_FDS;
      this.ProjectDetails_FDS = [];
    }
    this.FilteredProposalDetails = [];
    this.spinner.hide();
  }
  clearScopeSelection() {
    sessionStorage.removeItem("clientName");
    sessionStorage.removeItem("e2eDeliveryConstructName");
    sessionStorage.removeItem("deliveryParentConstructName");
    sessionStorage.removeItem("deliveryConstructName");
  }

  getProposalName(clientName){
    let strclientName = clientName;
    if(clientName.length > 30){
      strclientName = clientName.slice(0,30) + '...';
    }
    return strclientName;
  }
  nextPage() {
    this.currentPage++;
    this.DistinctClientList = [...new Set(this.proposal.ProposalDetail.map(x => x.ClientName))];

    this.totalPage = Math.ceil(this.DistinctClientList.length / this.barnumber);
    this.DistinctClientList1 = this.DistinctClientList.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
   
  }

  prevPage() {
    this.currentPage--;
      this.DistinctClientList = [...new Set(this.proposal.ProposalDetail.map(x => x.ClientName))];

      this.totalPage = Math.ceil(this.DistinctClientList.length / this.barnumber);
      this.DistinctClientList1 = this.DistinctClientList.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);     
  }
}
